import { cn } from "@dalmatech/ui"

const root = cn("")
const container = (
  isPricingPage?: boolean,
  isBannerDisplayed?: boolean,
  isRedirectIntoPrepackage?: boolean,
  isAttributionQuestion?: boolean,
  isPrepackage?: boolean,
  isRecap?: boolean,
  isTribe?: boolean,
  isMultiPetPrepackageBanner?: boolean,
  isWelcomePage?: boolean
) =>
  cn(
    "px-4 pt-[7rem] md:pt-[6.75rem] lg:pt-[7rem] pb-28 box-border",
    isRedirectIntoPrepackage ? "px-4" : "",
    isPricingPage ? "px-4 md:pt-16" : "",
    isAttributionQuestion ? "md:pt-16" : "",
    isBannerDisplayed
      ? "pt-[10.25rem] min-[400px]:pt-[10.25rem] min-[800px]:pt-[10.25rem] lg:pt-[10.25rem]"
      : "",
    isPrepackage ? "overflow-x-hidden" : "",
    isRecap ? "md:pt-28" : "",
    isTribe ? "md:pt-16" : "",
    isMultiPetPrepackageBanner ? "pt-[142px] md:pt-[138px] lg:pt-[148px]" : "",
    isWelcomePage ? "pt-6 md:pt-10 lg:pt-10 pb-[6rem]" : ""
  )
const scroller = cn("relative")
export { container, root, scroller }
